export default __webpack_public_path__ + "static/media/enginecutoff.1a426b68.png";